__turbopack_context__.v({
  "className": "ibmplexmonofont_e135c6b6-module__hjvpOq__className",
  "variable": "ibmplexmonofont_e135c6b6-module__hjvpOq__variable",
});
